import { Directive, ElementRef, inject, OnDestroy, OnInit } from '@angular/core';
import { DeviceInfoService } from '@core/services/device-info.service';
import { NgSelectComponent } from '@ng-select/ng-select';
import {
  isMobileOverlayBackButtonExcluded,
  MobileOverlayBackButtonHandler,
} from './mobile-overlay-back-button-handler';

type Unsubscribable = {
  unsubscribe: () => void;
};

@Directive({
  // eslint-disable-next-line @angular-eslint/directive-selector
  selector: 'ng-select',
  standalone: false,
})
export class NgSelectMobileBackButtonDirective implements OnInit, OnDestroy {
  private readonly ngSelect = inject(NgSelectComponent);
  private readonly elementRef = inject<ElementRef<Element>>(ElementRef);
  private readonly deviceInfoService = inject(DeviceInfoService);
  private readonly mobileBackHandler = new MobileOverlayBackButtonHandler({
    isOverlayOpen: () => this.ngSelect.isOpen(),
    closeOverlay: () => this.ngSelect.close(),
    shouldHandleBackButton: () =>
      this.deviceInfoService.getInfo().deviceTypeDetected === 'PHONE' &&
      !isMobileOverlayBackButtonExcluded(this.elementRef.nativeElement),
  });
  private openSubscription?: Unsubscribable;
  private closeSubscription?: Unsubscribable;

  public ngOnInit(): void {
    this.openSubscription = this.ngSelect.openEvent.subscribe(() => this.mobileBackHandler.handleOpened());
    this.closeSubscription = this.ngSelect.closeEvent.subscribe(() => this.mobileBackHandler.handleClosed());
  }

  public ngOnDestroy(): void {
    this.mobileBackHandler.destroy();
    this.openSubscription?.unsubscribe();
    this.closeSubscription?.unsubscribe();
  }
}
